import {PredictionTypeEnum, StockSignalsEnum} from "../../dict";
import {FilterUserAverageScoreRange} from "../api";

export enum StockTriggerType {
    PREDICTION      = 1,
    SIGNAL          = 2,
}

export enum SignalDirectionType {
    UP      = 1,
    DOWN    = -1,
}

export enum DirectionType {
    UP  = 1,
    DOWN = -1,
}

export enum SignalRepeatType {
    PRIMARY     = 1,
    REPEAT      = 2,
}

export interface SignalItem {
    type: StockSignalsEnum;
    repeatTypes: SignalRepeatType[];
    directionTypes: SignalDirectionType[];
    repeatSecs: number;
    oppositeDirection: boolean;
    cancellationSecs: number;
}

export interface SignalSetup {
    signals: SignalItem[];
    intersectionSecs: number;
    prevClosePriceThreshold?: number,
    condition: 'or'|'and';
}

export enum GroupDirectionType {
    DIR_SUM = 1,
    PERCENTAGE = 2,
}

export class AnalysisDirGroupEntity {
    profitCount: number = 0;
    profitRate: number = 0;
    profitAmountSum: number = 0;
    profitAmountAvg: number = 0;

    lossCount: number = 0;
    lossRate: number = 0;
    lossAmountSum: number = 0;
    lossAmountAvg: number = 0;

    atCloseCount: number = 0;
    atCloseProfitRateSum: number = 0;
    atCloseRate: number = 0;
    atCloseAmountSum: number = 0;
    atCloseAmountAvg: number = 0;

    atExitSignalCount: number = 0;
    atExitSignalRateSum: number = 0;
    atExitSignalRate: number = 0;
    atExitSignalAmountSum: number = 0;
    atExitSignalAmountAvg: number = 0;

    atExitStepSizeCount: number = 0;
    atExitStepSizeRateSum: number = 0;
    atExitStepSizeAmountSum: number = 0;
    atExitStepSizeRate: number = 0;
    atExitStepSizeAmountAvg: number = 0;

    totalCount: number = 0; // number of items to get "sumDirection"
    groupDirection: number = null as any;
    groupDirectionType: GroupDirectionType = null as any;

    overallProfitRate: number = 0;
    overallProfitAmount: number = 0;
}

export interface AnalysisScore {
    score: {
        overall: number;
        positiveDirection: number;
        negativeDirection: number;
        [key:string]: number
    },
    trades: {
        total: number;
        positiveDirection: number;
        negativeDirection: number;
    }
}

export type AnalysisOutputParams = {
    stats: AnalysisScore;
    perfStats: {
        totalMsec: number,
        openByPredCount: number,
        openByPredMsec: number,

        openBySignalPredsCount: number,
        openBySignalPredsMsec: number,

        openBySignalStockStatsCount: number,
        openBySignalStockStatsMsec: number,

        closeBySignalPredsCount: number,
        closeBySignalPredsMsec: number,

        closeBySignalStockStatsCount: number,
        closeBySignalStockStatsMsec: number,

        aggregateWindowGroupsMsec: number,
        calcWindowDataMsec: number,
        openTriggersQueryStockMsec: number,

        [key:string]: number,

    },
    result: AnalysisDirGroupEntity[],
}

export interface PrevCurDayPriceGap {
    direction: DirectionType, // gap up or down
    diffMinRate: number, // gap size in pct/100

}

export type AnalysisInputParams = {

    groupDirectionType: GroupDirectionType;

    openTriggerType:  StockTriggerType;
    openTriggerDirectionTypes?: DirectionType[];

    openSignalSetup?: SignalSetup;
    // openSignalType: StockSignalsEnum;
    // openSignalRepeatTypes: SignalRepeatType[];
    // openSignalRepeatSecs: number;
    // openSignalOppositeDirection: boolean;

    closeSignalSetup?: SignalSetup;
    // closeSignalType: StockSignalsEnum;
    // closeSignalRepeatTypes: SignalRepeatType[];
    // closeSignalRepeatSecs: number;
    // closeSignalOppositeDirection: boolean;

    closeStepSizeRate: number|null;

    prevCurDayPriceGap?: PrevCurDayPriceGap,

    startTime: number;
    endTime: number;

    stockSymbolId: number,

    // use extra symbol prediction's data for analysis
    // extraSymbolNames?: [],
    extraSymbolIds?: number[],

    predictionTypes: PredictionTypeEnum[], // list of types to analyze
    predictionIds: number[]|undefined;
    predictionUserIds: number[]|undefined;
    predictionFirstMinStepSizeMoveMax?: number, // step size move threshold for first min (pred made + 1m)

    // for signals and predictions
    userAverageScore?: FilterUserAverageScoreRange;

    // use preds within windows up to current pred made time
    windowTimeSecs: number, // Period of time to consider the predictions, to use for net sum of the predictions directions in the window period.

    windowMinElements: number, // Minimum number of predictions involved in the window period.

    aheadTimeSecs: number, // Period of time ahead of prediction time to consider in, use stock stats for comparison in next N minutes

    startHourEst: number, // Remove triggers before this hour for the analysis (not for the cumulative computations).
    endHourEst: number, // Remove triggers after this hour for the analysis (not for the cumulative computations).

    // fixInvalidScores: number,
    // useExitSignal: number,

    takeProfitRate: number,
    // take_profit = st.slider("Take Profit", 0.05, 0.5, 0.15, step=0.01)

    stopLossRate: number; // default 0.15% - negative
    // stop_loss = st.slider("Stop Loss", -0.5, -0.05, -0.15, step=0.01)

    // exitSignalType: StockSignalsEnum|null;
    // signalRepeatIntervalSecs: number;
}
